class ZerraBrandsMarquee {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('[data-brands-track]');
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.baseSeconds = parseFloat(el.dataset.speed || '28');

    if (!this.track) return;

    const source = this.track.querySelector('[data-brands-group]');
    if (!source) return;

    this.sourceTemplate = source.innerHTML;

    if (this.reduceMotion) {
      el.classList.add('is-static');
      return;
    }

    this.prepareTrack();
    this.syncDuration();
    this.bindPause();

    window.addEventListener('resize', () => {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => {
        this.prepareTrack();
        this.syncDuration();
      }, 150);
    });
  }

  prepareTrack() {
    const source = this.track.querySelector('[data-brands-group]');
    if (!source || !this.sourceTemplate) return;

    // Solo due metà uguali per translateX(-50%)
    [...this.track.querySelectorAll('[data-brands-group-clone], .zerra-brands__group--clone')].forEach((node) => {
      node.remove();
    });

    source.innerHTML = this.sourceTemplate;

    let safety = 0;
    while (source.scrollWidth < this.el.offsetWidth * 1.15 && safety < 8) {
      source.insertAdjacentHTML('beforeend', this.sourceTemplate);
      safety += 1;
    }

    const clone = source.cloneNode(true);
    clone.classList.add('zerra-brands__group--clone');
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('data-brands-group');
    clone.setAttribute('data-brands-group-clone', '');
    this.track.appendChild(clone);
  }

  syncDuration() {
    const source = this.track.querySelector('[data-brands-group]');
    if (!source) return;

    const width = source.scrollWidth;
    if (!width) return;

    const pxPerSecond = Math.max(36, 920 / this.baseSeconds);
    const duration = Math.max(14, width / pxPerSecond);
    this.track.style.setProperty('--brands-duration', `${duration.toFixed(2)}s`);
  }

  bindPause() {
    const pause = () => this.el.classList.add('is-paused');
    const resume = () => this.el.classList.remove('is-paused');

    this.el.addEventListener('mouseenter', pause);
    this.el.addEventListener('mouseleave', resume);
    this.el.addEventListener('focusin', pause);
    this.el.addEventListener('focusout', (e) => {
      if (!this.el.contains(e.relatedTarget)) resume();
    });
  }
}

function initZerraBrands(root = document) {
  root.querySelectorAll('[data-brands-marquee]:not([data-brands-init])').forEach((el) => {
    el.setAttribute('data-brands-init', 'true');
    new ZerraBrandsMarquee(el);
  });
}

document.addEventListener('DOMContentLoaded', () => initZerraBrands());
document.addEventListener('shopify:section:load', (e) => initZerraBrands(e.target));
